import { render, staticRenderFns } from "./FiscalObligations.vue?vue&type=template&id=252888d3&scoped=true&"
import script from "./FiscalObligations.vue?vue&type=script&lang=js&"
export * from "./FiscalObligations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252888d3",
  null
  
)

export default component.exports